import React from 'react';
import { Pagination as SemanticPagination, Select } from 'semantic-ui-react';
import styled from 'styled-components';
import useTheme from 'theme/useTheme';

const PaginationContainer = styled.div`
  padding: 8px;
  border-radius: 6px;
  ${({ shadowed }) => shadowed && `
    background-color: #fff;
    box-shadow: 0 5px 10px rgb(0, 0, 0, 0.2);
  `}
  display: flex;
  align-items: center;
  justify-content: center;
`;

const LimitContainer = styled.div`
  display: flex;
  align-items: center;
  margin-right: 15px;
  .ui.selection.dropdown {
    min-width: 70px !important;
    width: 70px;
  }
  > span {
    display: block;
    margin: 0 10px;
    height: 20px;
  }
`;

const Pagination = ({
  limit, page, total, limitValues = ['15', '30', '50', '100'], updateLimit, updatePage, shadowed, text = 'ideas',
}) => {
  const theme = useTheme();
  return (
    <PaginationContainer shadowed={shadowed}>
      {!theme.sizes.isMobile
        && (
          <LimitContainer>
            <span>Showing</span>
            <Select
              options={limitValues.map(v => ({ key: v, text: v, value: v }))}
              value={String(limit)}
              onChange={(e, { value }) => updateLimit(value)}
            />
            <span>
              {`of ${total} total ${text}`}
            </span>
          </LimitContainer>
        )
      }
      <SemanticPagination
        onPageChange={(e, { activePage }) => updatePage(activePage)}
        activePage={page || 1}
        totalPages={parseInt(total / limit, 10) + 1}
        boundaryRange={1}
        siblingRange={1}
        ellipsisItem={null}
        firstItem={null}
        lastItem={null}
        color="blue"
      />
    </PaginationContainer>
  );
};

export default Pagination;
